import {
    FETCH_UNREAD_NOTIFICATIONS_COUNT, FETCH_UNREAD_NOTIFICATIONS_COUNT_ERROR,
    FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS, FETCH_USER_NOTIFICATIONS_UNREAD, FETCH_USER_NOTIFICATIONS_UNREAD_ERROR,
    FETCH_USER_NOTIFICATIONS_UNREAD_SUCCESS, MARK_USER_NOTIFICATION_AS_READ, MARK_USER_NOTIFICATION_AS_READ_ERROR,
    MARK_USER_NOTIFICATION_AS_READ_SUCCESS,
    UserNotificationActionTypes
} from "../../actions/user/NotificationActions";
import { RequestState } from "../../models/common/RequestState";
import { Notification } from "../../models/users/Notification";

export interface UserNotificationState {
    numberOfUnreadNotifications: number
    unreadNotifications: Notification[] | null
    request: RequestState
}

const initialState: UserNotificationState = {
    numberOfUnreadNotifications: 0,
    unreadNotifications: null,
    request: {
        isFetching: false,
        error: null,
        lastRequestSuccess: 0
    }
};

export const NotificationReducer = ( state = initialState, action: UserNotificationActionTypes ): UserNotificationState => {
    switch( action.type ) {
        case FETCH_UNREAD_NOTIFICATIONS_COUNT:
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS:
            return {
                ...state,
                numberOfUnreadNotifications: action.numberOfUnreadNotifications,
                request: {
                    error: null,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_UNREAD_NOTIFICATIONS_COUNT_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    error: action.error,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_NOTIFICATIONS_UNREAD:
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_NOTIFICATIONS_UNREAD_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.unreadNotifys,
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_USER_NOTIFICATIONS_UNREAD_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case MARK_USER_NOTIFICATION_AS_READ:
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case MARK_USER_NOTIFICATION_AS_READ_SUCCESS:
            return {
                ...state,
                numberOfUnreadNotifications: ( state.numberOfUnreadNotifications - 1 ),
                unreadNotifications: ( state.unreadNotifications !== null )
                    ? state.unreadNotifications.filter( notify => notify.id.rawValue !== action.id )
                    : null,
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case MARK_USER_NOTIFICATION_AS_READ_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        default:
            return state;
    }
};